import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import CtaButton from './CtaButton';
import BookMockup from './BookMockup';
import {heroBullets} from '../data/content';

const {FiCheckCircle} = FiIcons;

function Hero() {
  return (
    <section id="top" className="mx-auto grid max-w-6xl items-center gap-12 px-4 py-14 lg:grid-cols-[1.2fr_0.8fr] lg:py-24">
      <div>
        <span className="inline-block rounded-full bg-red-50 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-[#D52B1E]">
          Der aktuelle Schritt-für-Schritt-Leitfaden für Deutsche
        </span>
        <h1 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-[#111827] sm:text-5xl">
          Auswandern in die Schweiz: Sicher, strukturiert und ohne teure Anfängerfehler in dein neues Leben starten.
        </h1>
        <p className="mt-5 max-w-xl text-lg text-gray-600">
          Von Aufenthaltsbewilligung, Jobsuche und Steuern bis hin zu Wohnung, Krankenkasse und Altersvorsorge – der große Praxisratgeber für einen reibungslosen Neustart.
        </p>
        <ul className="mt-6 space-y-3">
          {heroBullets.map((b) => (
            <li key={b} className="flex items-center gap-3 font-medium text-[#111827]">
              <SafeIcon icon={FiCheckCircle} className="text-xl flex-none text-[#1E3A8A]" aria-hidden="true" />
              {b}
            </li>
          ))}
        </ul>
        <div className="mt-8">
          <CtaButton large>Jetzt auf Amazon sichern (Taschenbuch &amp; Kindle)</CtaButton>
          <p className="mt-3 text-sm font-medium text-green-700">
            ✓ Taschenbuch &amp; Kindle • Sicher bestellen über Amazon.de
          </p>
        </div>
      </div>
      <aside aria-label="Buchcover">
        <BookMockup eager />
      </aside>
    </section>
  );
}

export default Hero;